import React, { useEffect, useState } from "react";

import styled from "styled-components";

interface TypewriterProps {
  text: string;
  delay: number;
  scrollRef: React.RefObject<HTMLDivElement>;
  setTypeStatus: React.Dispatch<
    React.SetStateAction<"init" | "typing" | "done">
  >;
}

const TypewriterWrapper = styled.div`
  margin: 1rem;
`;

const Typewriter: React.FC<TypewriterProps> = ({
  text,
  delay = 30,
  scrollRef,
  setTypeStatus,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  useEffect(() => {
    let currentIndex = 0;
    setDisplayedText("");
    setTypeStatus("typing");

    const interval = setInterval(() => {
      if (currentIndex < text.length) {
        setDisplayedText((prev) => {
          const updated = prev + text[currentIndex];
          // Scroll after DOM updates
          requestAnimationFrame(() => {
            if (scrollRef?.current) {
              scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            }
          });
          return updated;
        });
        currentIndex++;
      } else {
        clearInterval(interval);
        setTypeStatus("done");
      }
    }, delay);

    return () => {
      clearInterval(interval);
      setTypeStatus("done");
    };
  }, [text, delay, scrollRef]);

  return <TypewriterWrapper>{displayedText}</TypewriterWrapper>;
};

export default Typewriter;
